import http from "./http";

// Vehículos personales
export const getPassengerVehiculs = async (_id) => {
  const token = localStorage.getItem("token");
  const { data } = await http.get(
    `vehiculoPersonal/list_passenger_vehicles/${_id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const updatePassengerAccess = async (datos) => {
  const token = localStorage.getItem("token");
  const { data } = await http.put("vehiculoPersonal/autorizar_acceso", datos);
  return data;
};

export const updateVehicleAccess = async (datos) => {
  const token = localStorage.getItem("token");
  const { data } = await http.put(
    "vehiculoPersonal/autorizar_acceso_vehiculo",
    datos,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

// Tarifas
export const guardarCambiosTarifas = async (datos) => {
  const token = localStorage.getItem("token");
  const { data } = await http.post(
    "solicitudUnica/guardar_cambios_tarifas/",
    datos,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const obtenerTarifa = async () => {
  const token = localStorage.getItem("token");
  const { data } = await http.get("solicitudUnica/obtener_tarifas/", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const reprogramarSolicitud = async (datos) => {
  const token = localStorage.getItem("token");
  const { data } = await http.put(
    "solicitudUnica/reprogramar_solicitud/",
    datos,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const getFoliosSolicitudes = async () => {
  const token = localStorage.getItem("token");
  const { data } = await http.get("solicitudUnica/obtener_folios", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

// Bitácora Embarcación
export const insertBitacoraEmbarcación = async (datos) => {
  const token = localStorage.getItem("token");
  const { data } = await http.post("bitacoraEmbarcacion/add", datos, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const listAccesoFolio = async (folio) => {
  const token = localStorage.getItem("token");
  const { data } = await http.get(`bitacoraEmbarcacion/list/${folio}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const listBitacora = async () => {
  const token = localStorage.getItem("token");
  const { data } = await http.get("bitacoraEmbarcacion/list_bitacora", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

// Usuario
export const forgotPassword = async (email) => {
  const token = localStorage.getItem("token");
  const { data } = await http.post(
    "usuario/request-reset",
    { email },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const resetPassword = async (tokenParam, password) => {
  const token = localStorage.getItem("token");
  const { data } = await http.post(
    "usuario/reset-password",
    { token: tokenParam, password },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

// Tickets
export const crearTicket = async (datos) => {
  const token = localStorage.getItem("token");
  const { data } = await http.post("tickets/add", datos, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const getTickets = async () => {
  const token = localStorage.getItem("token");
  const { data } = await http.get("tickets/", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const allTickets = async () => {
  const token = localStorage.getItem("token");
  const { data } = await http.get("tickets/all_tickets", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const getTicketsEstatus = async (estatus) => {
  const token = localStorage.getItem("token");
  const { data } = await http.post(
    "tickets/tickets",
    { estatus },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const addLogs = async (datos, _id) => {
  const token = localStorage.getItem("token");
  const { data } = await http.post(`tickets/add_logs/${_id}`, datos, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const updateEstatus = async (estatus, _id) => {
  const token = localStorage.getItem("token");
  const { data } = await http.post(
    `tickets/update_estatus/${_id}`,
    { estatus },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const getUsuariosPorAgencia = async (agencia, estado) => {
  const token = localStorage.getItem("token");
  const { data } = await http.get("tickets/usuarios_por_agencia", {
    params: { agencia, estado },
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const getTicketsId = async (_id) => {
  const token = localStorage.getItem("token");
  const { data } = await http.get(`tickets/get_ticket_id/${_id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const generarPdfSU = async (datos) => {
  const token = localStorage.getItem("token");
  try {
    const response = await http.post(
      `solicitudUnica/generar_reporte_su`,
      datos,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response; // Retorna el blob directamente
  } catch (error) {
    console.error("Error al generar el PDF:", error.response || error.message);
    throw error; // Lanza el error para manejarlo en el componente
  }
};

export const generarPdfCG = async (datos) => {
  const token = localStorage.getItem("token");
  const response = await http.post(`cambioGuardia/generar_reporte_cg`, datos, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response; // Retorna el blob directamente
};

export const generarPdfVP = async (datos) => {
  const token = localStorage.getItem("token");
  const response = await http.post(
    `vehiculoPersonal/generar_reporte_vp`,
    datos,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response; // Retorna el blob directamente
};

export const guardarPsp = async (datos) => {
  const token = localStorage.getItem("token");
  const response = await http.post(`psp/add`, datos, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response; // Retorna el blob directamente
};

export const listarPsp = async (datos, page) => {
  const token = localStorage.getItem("token");
  const response = await http.get(`psp/list`, {
    params: { page },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const guardarDocFinPsp = async (datos) => {
  const token = localStorage.getItem("token");
  const response = await http.post(`psp/add_doc_fin`, datos, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const listDocFinPsp = async (idPsp) => {
  const token = localStorage.getItem("token");
  const response = await http.get(`psp/list_doc_fin/${idPsp}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const listDocTecPsp = async (idPsp) => {
  const token = localStorage.getItem("token");
  const response = await http.get(`psp/list_doc_tec/${idPsp}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const guardarDocTecPsp = async (datos) => {
  const token = localStorage.getItem("token");
  const response = await http.post(`psp/add_doc_tec`, datos, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const listDocCartasPsp = async (idPsp) => {
  const token = localStorage.getItem("token");
  const response = await http.get(`psp/list_doc_cartas/${idPsp}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const guardarDocCartasPsp = async (datos) => {
  const token = localStorage.getItem("token");
  const response = await http.post(`psp/add_doc_cartas`, datos, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const listDocGeneralPsp = async (idPsp) => {
  const token = localStorage.getItem("token");
  const response = await http.get(`psp/list_doc_general/${idPsp}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const guardarDocGeneralPsp = async (datos) => {
  const token = localStorage.getItem("token");
  const response = await http.post(`psp/add_doc_general`, datos, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const listEvidenciaPsp = async (idPsp) => {
  const token = localStorage.getItem("token");
  const response = await http.get(`psp/evidencia_psp/${idPsp}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const guardarEvidenciaPsp = async (datos) => {
  const token = localStorage.getItem("token");
  const response = await http.post(`psp/add_evidencia`, datos, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const deleteEvidenciaPsp = async (_id) => {
  const token = localStorage.getItem("token");
  const response = await http.delete(`psp/delete_evidencia/${_id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const generarPdfPsp = async (datos) => {
  const token = localStorage.getItem("token");
  const response = await http.post(`psp/generar_reporte_psp`, datos, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response; // Retorna el blob directamente
};

export const actualizarAccesoPsp = async (datos, id) => {
  const token = localStorage.getItem("token");
  const response = await http.put(`psp/update_access_psp/${id}`, datos, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response; // Retorna el blob directamente
};

export const actualizarAccesoFinanzas = async (datos, id) => {
  const token = localStorage.getItem("token");
  const response = await http.put(`psp/update_access_finanzas/${id}`, datos, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response; // Retorna el blob directamente
};

export const aut1 = async (id) => {
  const token = localStorage.getItem("token");

  const response = await http.post(`psp/aut1/${id}`, null, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response; // Retorna el blob directamente
};

export const cancellSolUnica = async (id, motivo) => {
  const token = localStorage.getItem("token");

  const response = await http.put(
    `solicitudUnica/cancell`,
    { motivo_cancell: motivo, _id: id },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
};

export const cancelCambioGuardia = async (id, motivo) => {
  const token = localStorage.getItem("token");

  const response = await http.put(
    `cambioGuardia/cancell`,
    { motivo_cancell: motivo, _id: id },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
};

export const cancelVP = async (id, motivo) => {
  const token = localStorage.getItem("token");

  const response = await http.put(
    `vehiculoPersonal/cancell`,
    { motivo_cancell: motivo, _id: id },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
};

export const addFeedback = async (data) => {
  const token = localStorage.getItem("token");

  const response = await http.post(`feedback/add`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export const getFeedbackUser = async () => {
  const token = localStorage.getItem("token");

  const response = await http.get(
    `feedback/survey-status`,

    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
};

export const getAllSurvey = async () => {
  const token = localStorage.getItem("token");

  const response = await http.get(
    `feedback/`,

    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
};

export const updatePSPestatus = async (idPsp, estatus) => {
  const token = localStorage.getItem("token");
  const { data } = await http.put(
    `psp/update_psp_estatus`,
    { idPsp, estatus },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const listarPSPestatus = async (datos, page) => {
  const token = localStorage.getItem("token");
  const { data } = await http.get(`psp/listar_psp_estatus`, {
    params: { datos, page },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

export const actualizarMontoContraprestacion = async (idPsp, monto) => {
  const token = localStorage.getItem("token");
  try {
    const { data } = await http.put(
      `psp/update_contraprestacion_previa`,
      { _id: idPsp, monto },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    console.error(
      "Error al actualizar el monto:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const actualizarAccesoPosteriorPsp = async (info, idPsp) => {
  const token = localStorage.getItem("token");
  try {
    const { data } = await http.put(
      `psp/update_psp_posterior/${idPsp}`,
      info,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    console.error(
      "Error al actualizar el monto:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// TODO: Agregar endpoint de buscar folio, son dos endpoints uno para vehiculosPersonal y cambiosGuardia

export const buscarFolioCambioGuardia = async (folio) => {
  const token = localStorage.getItem("token");
  const folioGuardia = typeof folio === "string" ? folio.split("/")[0] : folio;
  try {
    const response = await http.get(
      `/cambioGuardia/buscarFolioCambioGuardia/${folioGuardia}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error al buscar los datos del folio:",
      error.response || error.message
    );
    throw error;
  }
};

export const buscarFolioVehiculosPersonal = async (folio) => {
  const token = localStorage.getItem("token");
  const folioVehiculo = typeof folio === "string" ? folio.split("/")[0] : folio;
  try {
    const response = await http.get(
      `/vehiculoPersonal/buscarFolioVehiculosPersonal/${folioVehiculo}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error al buscar los datos del folio:",
      error.response || error.message
    );
    return null;
  }
};
// Dashboard
export const cantidadSolicitudesAgenicia = async (datos) => {
  const token = localStorage.getItem("token");
  try {
    const { data } = await http.post(
      `dashboard/cantidad_solicitudes_agencia`,
      datos,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    console.error(
      "Error al buscar solicitudes por agencia:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const cantidadSolicitudesEnElTiempo = async (datos) => {
  const token = localStorage.getItem("token");
  try {
    const { data } = await http.post(
      `dashboard/cantidad_solicitudes_en_el_tiempo`,
      datos,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    console.error(
      "Error al buscar solicitudes en el tiempo:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const selectAgencias = async () => {
  const token = localStorage.getItem("token");
  try {
    const { data } = await http.get(`dashboard/listar_agencias`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.error(
      "Error al buscar solicitudes por agencia:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const cantidadSolicitudesCompania = async (datos) => {
  const token = localStorage.getItem("token");
  try {
    const { data } = await http.post(
      `dashboard/cantidad_solicitudes_por_compania`,
      datos,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data;
  } catch (error) {
    console.error(
      "Error al buscar solicitudes por compania:",
      error.response?.data || error.message
    );
    throw error;
  }
};
